<template>
  <div class="bank_open">
    <el-divider content-position="left">银行开户进度</el-divider>
    <el-row>
      <el-col :span="4">
        <el-col :span="23">
          <el-select
            v-model="searchArr.company_id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入公司名称筛选公司"
            size="mini"
            clearable
            :remote-method="searchRemoteCompanyMethod"
            :loading="searchLoading"
            @change="handleSearchCompanyChange"
          >
            <el-option
              v-for="searchCompany in searchCompanies"
              :key="searchCompany.id"
              :label="searchCompany.company_name"
              :value="searchCompany.id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-col>
      <el-col :span="4">
        <el-col :span="23">
          <el-select
            v-model="searchArr.id"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入订单编号"
            size="mini"
            @change="handleOrderChange"
            :remote-method="remoteMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in orderNums"
              :key="item.id"
              :label="item.order_num"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-col>
      <el-col :span="4">
        <el-col :span="23">
          <el-select
            collapse-tags
            v-model="searchArr.status"
            placeholder="请选择办理完成状态"
            @change="handleOrderChange"
            size="mini"
            clearable
          >
            <el-option :value="1" label="整理材料"></el-option>
            <el-option :value="2" label="开户办理"></el-option>
            <el-option :value="3" label="开户完成"></el-option>
          </el-select>
        </el-col>
      </el-col>
      <el-col :span="2" style="margin-right: 5px">
        <el-popover placement="bottom-start" v-model="searchVisible" width="320">
          <el-row style="margin-bottom: 0.4rem; padding-top: 0.5rem">
            <el-col :span="6" style="margin-top: 0.1rem">服务状态：</el-col>
            <el-col :span="18">
              <el-select
                v-model="searchArr.service_status"
                placeholder="请选择"
                size="mini"
                clearable
              >
                <el-option :value="3" label="服务中"></el-option>
                <el-option :value="4" label="服务完成"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">沟通顾问：</el-col>
            <el-col :span="18">
              <el-cascader
                v-model="searchArr.consultant"
                placeholder="请选择沟通顾问"
                :options="users"
                size="mini"
                :props="{ expandTrigger: 'hover' }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">行业特点：</el-col>
            <el-col :span="18">
              <el-select
                v-model="searchArr.feature"
                filterable
                placeholder="请选择"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in features"
                  :key="item.industry_id"
                  :label="item.industry_name"
                  :value="item.industry_id"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">注册类型：</el-col>
            <el-col :span="18">
              <el-select
                v-model="searchArr.actual_reg_type"
                filterable
                placeholder="请选择"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in regTypes"
                  :key="item.reg_type_id"
                  :label="item.reg_type_name"
                  :value="item.reg_type_id"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">服务人员：</el-col>
            <el-col :span="18">
              <el-cascader
                v-model="searchArr.operator"
                placeholder="请选择服务人员"
                :options="usersConvert"
                size="mini"
                :props="{ expandTrigger: 'hover' }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">订单来源：</el-col>
            <el-col :span="18">
              <el-select
                v-model="searchArr.platform"
                filterable
                placeholder="请选择"
                clearable
                size="mini"
                @click.native="getFrom"
              >
                <el-option
                  v-for="item in fromOptions"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem">
            <el-col :span="6" style="margin-top: 0.1rem">公司园区：</el-col>
            <el-col :span="18">
              <el-select
                v-model="searchArr.park"
                filterable
                placeholder="请选择"
                clearable
                size="mini"
              >
                <el-option
                  v-for="option in parks"
                  :key="option.id"
                  :label="option.areaName"
                  :value="option.id"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
            <el-col :span="12" :offset="12">
              <el-button size="mini" @click="handleClearSearchGetData">清除</el-button>
              <el-button type="primary" @click="handleSearchGetData" size="mini"
                >查询</el-button
              >
            </el-col>
          </el-row>
          <el-button slot="reference" size="mini">筛选</el-button>
        </el-popover>
      </el-col>
    </el-row>
    <el-table
    height="calc(100vh - 276px)"
      :data="orders"
      size="medium"
      style="width: 100%; margin-top: 0.2rem"
      v-cloak
      border
    >
      <el-table-column label="订单编号" width="200" fixed>
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.order_num" placement="top">
            <div class="company_hover">
              <span class="count_style" style="display: inherit">
                <el-link
                  class="ellipsis-link"
                  type="primary"
                  @click="handleOrderInfo(scope.row.id, scope.row.order_num)"
                  >{{ scope.row.order_num }}</el-link
                >
              </span>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed label="服务状态" width="90">
        <template slot-scope="scope">
          <div v-if="scope.row.service_status === '服务中'">
            <span class="dot" style="background-color: #88d023"></span>
            <el-link disabled>{{ scope.row.service_status }}</el-link>
          </div>
          <div v-else>
            <span class="dot" style="background-color: #ff8839"></span>
            <el-link disabled>{{ scope.row.service_status }}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="公司名称" width="200">
        <template slot-scope="scope">
          <el-tooltip
            :content="
              scope.row.company
                ? scope.row.company
                : scope.row.order_reg
                ? scope.row.order_reg.is_tax_report === 2
                  ? '公司注册中...'
                  : ''
                : ''
            "
            placement="top"
          >
            <el-link
              v-if="scope.row.company_id"
              type="primary"
              class="count-style"
              @click="fhandleCompanyInfoOpen(scope.row.company_id)"
              >{{ scope.row.company ? scope.row.company : "" }}</el-link
            >
            <span v-else class="count_style" style="display: inherit">{{
              scope.row.company
                ? scope.row.company
                : scope.row.order_reg
                ? scope.row.order_reg.is_tax_report === 2
                  ? "公司注册中..."
                  : ""
                : ""
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="订单来源" width="100">
        <template slot-scope="scope">
            <span class="hide-style">{{ scope.row.platform }}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单类型" width="120">
        <template slot-scope="scope">
            <span class="count_style" style="display: inherit">{{
              scope.row.order_reg ? scope.row.order_reg.order_reg_name : ""
            }}</span>
        </template>
      </el-table-column>
      <el-table-column label="顾问">
        <template slot-scope="scope">
            <span class="hide-style">{{
              scope.row.advisor ? scope.row.advisor.username : ""
            }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户名称" width="170">
        <template slot-scope="scope">
            <span class="hide-style">{{ scope.row.customer_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户电话" width="170">
        <template slot-scope="scope">
            <!-- <span class="hide-style">{{ scope.row.customer_phone }}</span> -->
            <phone-com v-if="scope.row.customer_phone"
                  :comPhone="scope.row.customer_phone"
                  :vagaryPhone="scope.row.vagary_phone_custome"
                  style="display: inline-block"
                />
        </template>
      </el-table-column>
      <el-table-column label="法人名称" width="110">
        <template slot-scope="scope">
            <span class="hide-style">{{ scope.row.corporate_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="法人电话" width="170">
        <template slot-scope="scope">
            <!-- <span class="hide-style">{{ scope.row.corporate_phone }}</span> -->
            <phone-com v-if="scope.row.corporate_phone"
                  :comPhone="scope.row.corporate_phone"
                  :vagaryPhone="scope.row.vagary_phone_corporate"
                  style="display: inline-block"
                />
        </template>
      </el-table-column>
      <!-- <el-table-column label="确认材料" width="100">
        <template slot-scope="scope">
          <span class="hide-style" style="color: red; opacity: 0.75" v-if="!scope.row.step_one">未处理</span>
          <span class="hide-style" style="color: green; opacity: 0.75" v-if="scope.row.step_one && scope.row.step_one.is_finish === 1">办理中</span>
          <span class="hide-style" style="color: orange; opacity: 0.75" v-if="scope.row.step_one && scope.row.step_one.is_finish === 2">已完成</span>
        </template>
      </el-table-column>
      <el-table-column label="整理材料" width="100">
        <template slot-scope="scope">
          <span class="hide-style" style="color: red; opacity: 0.75" v-if="!scope.row.step_two">未处理</span>
          <span class="hide-style" style="color: green; opacity: 0.75" v-if="scope.row.step_two && scope.row.step_two.is_finish === 1">办理中</span>
          <span class="hide-style" style="color: orange; opacity: 0.75" v-if="scope.row.step_two && scope.row.step_two.is_finish === 2">已完成</span>
        </template>
      </el-table-column>
      <el-table-column label="园区操作" width="100">
        <template slot-scope="scope">
          <span class="hide-style" style="color: red; opacity: 0.75" v-if="!scope.row.step_three">未处理</span>
          <span class="hide-style" style="color: green; opacity: 0.75" v-if="scope.row.step_three && scope.row.step_three.is_finish === 1">办理中</span>
          <span class="hide-style" style="color: orange; opacity: 0.75" v-if="scope.row.step_three && scope.row.step_three.is_finish === 2">已完成</span>
        </template>
      </el-table-column>
      <el-table-column label="网厅申报" width="100">
        <template slot-scope="scope">
          <span class="hide-style" style="color: red; opacity: 0.75" v-if="!scope.row.step_four">未处理</span>
          <span class="hide-style" style="color: green; opacity: 0.75" v-if="scope.row.step_four && scope.row.step_four.is_finish === 1">办理中</span>
          <span class="hide-style" style="color: orange; opacity: 0.75" v-if="scope.row.step_four && scope.row.step_four.is_finish === 2">已完成</span>
        </template>
      </el-table-column>
      <el-table-column label="报到成功" width="100">
        <template slot-scope="scope">
          <span class="hide-style" style="color: red; opacity: 0.75" v-if="!scope.row.step_five">未处理</span>
          <span class="hide-style" style="color: green; opacity: 0.75" v-if="scope.row.step_five && scope.row.step_five.is_finish === 1">办理中</span>
          <span class="hide-style" style="color: orange; opacity: 0.75" v-if="scope.row.step_five && scope.row.step_five.is_finish === 2">已完成</span>
        </template>
      </el-table-column>
      <el-table-column label="客户与配合授权" width="130">
        <template slot-scope="scope">
          <span class="hide-style" style="color: red; opacity: 0.75" v-if="!scope.row.step_six">未处理</span>
          <span class="hide-style" style="color: green; opacity: 0.75" v-if="scope.row.step_six && scope.row.step_six.is_finish === 1">办理中</span>
          <span class="hide-style" style="color: orange; opacity: 0.75" v-if="scope.row.step_six && scope.row.step_six.is_finish === 2">已完成</span>
        </template>
      </el-table-column>
      <el-table-column label="天眼查完成截图" width="130">
        <template slot-scope="scope">
          <span class="hide-style" style="color: red; opacity: 0.75" v-if="!scope.row.step_seven">未处理</span>
          <span class="hide-style" style="color: green; opacity: 0.75" v-if="scope.row.step_seven && scope.row.step_seven.is_finish === 1">办理中</span>
          <span class="hide-style" style="color: orange; opacity: 0.75" v-if="scope.row.step_seven && scope.row.step_seven.is_finish === 2">已完成</span>
        </template>
      </el-table-column> -->
      <el-table-column fixed="right" label="操作" width="160">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="办理信息" placement="top">
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              type="info"
              circle
              @click="handleEditOpen(scope.$index, scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="电话联系记录" placement="top">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-phone-outline"
              circle
              @click="handCallLogsOpen(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="企业微信群聊天记录"
            placement="top"
          >
            <el-button
              type="warning"
              :disabled="scope.row.wx_work_chat_com ? false : true"
              @click="
                handleWxChatOpen(scope.row.wx_work_chat_com, scope.row.company_name)
              "
              size="mini"
              icon="el-icon-s-comment"
              circle
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="page-footer">
    <el-pagination
      background
      class="tr mt-10"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    </div>
    <el-drawer
      title="电话联系记录"
      :visible.sync="callLogsDrawer"
      direction="rtl"
      :before-close="handleCallLogsBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <call-logs
            :company="company"
            :phone="callPhone"
            :phone1="callPhone1"
            :phone2="callPhone2"
            :phone3="callPhone3"
          ></call-logs>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
    :title="'订单信息： ' + orderNum"
      :visible.sync="orderInfoVisible"
      direction="rtl"
      custom-class="AIdrawer"
      size="50%"
      :before-close="handleOrderInfoClose"
    >
    <div class="drawer-title" slot="title">订单信息： {{ orderNum }}</div>
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <order-info :orderId="orderInfoId" :checkType="bankCheckType"></order-info>
      </div>
    </el-drawer>
    <el-drawer
      title="公司信息"
      :visible.sync="companyInfoDrawer"
      direction="rtl"
      :before-close="handleCompanyInfoBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyInfoId"></company-info>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
    :title="'办理信息： ' + orderNum"
      :visible.sync="editDrawer"
      direction="rtl"
      custom-class="AIdrawer"
      :before-close="handleClearList"
      size="40%"
    >
    <div class="drawer-title" slot="title">办理信息： {{ orderNum }}</div>
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <el-col :span="24">
            <el-col>
              <el-col :span="4" :offset="1"
                ><span style="line-height: 28px">公司名称：</span></el-col
              >
              <el-col :span="19" v-if="companyName" style="line-height: 28px">{{
                companyName
              }}</el-col>
              <el-col :span="12" v-else>
                <el-select
                  v-model="companyId"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入公司字号筛选公司"
                  size="mini"
                  clearable
                  @change="handleCompanyChange"
                  :remote-method="remoteCompanyMethod"
                  :loading="loading"
                >
                  <el-option
                    v-for="company in companies"
                    :key="company.id"
                    :label="company.company_name"
                    :value="company.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-col>
          </el-col>
        </el-row>
        <el-row v-if="companyName">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="header-text">材料准备</span>
              <el-popconfirm
                title="确认完成吗？"
                @onConfirm="overCurrentItem(bankOpenOne.id, 1)"
              >
                <el-button
                  style="float: right"
                  slot="reference"
                  type="success"
                  size="mini"
                  :disabled="bankOpenOne.is_finish === 2"
                  plain
                  >完成</el-button
                >
              </el-popconfirm>
            </div>
            <div class="text item">
              <el-divider content-position="left"
                ><span class="top-line">银行信息</span></el-divider
              >
              <el-row>
                <el-col :span="4" class="m-label">
                  <el-tooltip content="银行名称" placement="top">
                    <span class="count_style" style="display: inherit">银行名称：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="7" class="m-label">
                  <el-select
                    collapse-tags
                    v-model="addForm.bank_name"
                    placeholder="请选择回单卡所属银行"
                    size="mini"
                    clearable
                  >
                    <el-option value="中国银行" label="中国银行"></el-option>
                    <el-option value="建设银行" label="建设银行"></el-option>
                    <el-option value="工商银行" label="工商银行"></el-option>
                    <el-option value="农业银行" label="农业银行"></el-option>
                    <el-option value="招商银行" label="招商银行"></el-option>
                    <el-option value="交通银行" label="交通银行"></el-option>
                    <el-option value="民生银行" label="民生银行"></el-option>
                    <el-option
                      value="上海浦东发展银行"
                      label="上海浦东发展银行"
                    ></el-option>
                    <el-option value="上海银行" label="上海银行"></el-option>
                    <el-option value="上海农商银行" label="上海农商银行"></el-option>
                    <el-option value="华夏银行" label="华夏银行"></el-option>
                    <el-option value="兴业银行" label="兴业银行"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1" class="m-label">
                  <el-tooltip content="开户银行" placement="top">
                    <span class="count_style" style="display: inherit">开户银行：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="7" class="m-label">
                  <el-input
                    v-model="addForm.bank_detail_name"
                    placeholder="请输入开户银行"
                    size="mini"
                    clearable
                  ></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" class="m-label">
                  <el-tooltip content="区域" placement="top">
                    <span class="count_style" style="display: inherit">区域：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="7">
                  <el-select
                    :filterable="true"
                    size="mini"
                    v-model="addForm.area"
                    placeholder="请选择区域"
                    clearable
                  >
                    <el-option
                      v-for="(item, index) in parks"
                      :key="index"
                      :label="item.areaName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1" class="m-label">
                  <el-tooltip content="银行地址" placement="top">
                    <span class="count_style" style="display: inherit">银行地址：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="7" class="m-label">
                  <el-input
                    v-model="addForm.bank_address"
                    placeholder="请输入银行地址"
                    size="mini"
                    clearable
                  ></el-input>
                </el-col>
              </el-row>
              <el-divider content-position="left"
                ><span class="top-line">客户到场信息</span></el-divider
              >
              <el-row>
                <el-col :span="4" class="m-label">
                  <el-tooltip content="是否到场" placement="top">
                    <span class="count_style" style="display: inherit">是否到场：</span>
                  </el-tooltip></el-col
                >
                <el-col :span="15" class="m-label">
                  <el-radio-group v-model="addForm.is_present" :size="inputSize">
                    <el-radio border label="否">否</el-radio>
                    <el-radio border label="是">是</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form :model="addForm" ref="addForm" label-width="100px" size="mini">
                    <el-card class="box-card m-col">
                      <el-upload
                        multiple
                        ref="upload"
                        action="#"
                        :limit="5"
                        :on-preview="handleLicensePreview"
                        :on-change="handleLicenseChange1"
                        :on-remove="handleLicenseRemove1"
                        :file-list="licenseList1"
                        accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                        list-type="file"
                        :auto-upload="false"
                      >
                        <el-link slot="trigger" type="primary" style="line-height: 28px"
                          >选择文件(最多可选择5个文件)</el-link
                        >
                      </el-upload>
                    </el-card>
                    <el-input
                      v-paste="handleParse1"
                      type="textarea"
                      placeholder="请点击此处，再粘贴复制的截图"
                    />
                  </el-form>
                </el-col>
              </el-row>
              <el-row>
                <el-col class="tr"
                  ><el-button
                    type="primary"
                    size="mini"
                    style="float: right"
                    @click="submitAddUpload('addForm', 1)"
                    :disabled="bankOpenOne.is_finish === 2"
                    >提交</el-button
                  ></el-col
                >
              </el-row>
              <el-row style="margin-bottom: 0">
                <el-col>
                  <el-collapse v-model="collapseOne" accordion>
                    <el-collapse-item title="文件信息">
                      <el-row>
                        <el-col>
                          <el-col :span="24">
                            <el-col :span="12">
                              <el-col :span="8">操作人员：</el-col>
                              <el-col :span="16">{{
                                bankOpenOne.handle_name ? bankOpenOne.handle_name : ""
                              }}</el-col>
                            </el-col>
                            <el-col :span="12">
                              <el-col :span="8">操作时间：</el-col>
                              <el-col :span="16">{{ bankOpenOne.update_at }}</el-col>
                            </el-col>
                          </el-col>
                        </el-col>
                      </el-row>
                      <el-row style="margin-bottom: 0; padding-bottom: 0">
                        <div class="demo-image__preview">
                          <el-divider
                            content-position="left"
                            v-if="bankOpenOne.images.length > 0"
                            >图片编辑</el-divider
                          >
                          <div
                            style="float: left"
                            v-for="(img, index) in bankOpenOne.images"
                            :key="index"
                          >
                            <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                              <el-image
                                style="width: 100px; height: 100px; padding: 0 5px 0 0"
                                :src="img"
                                :preview-src-list="bankOpenOne.images"
                              >
                              </el-image>
                            </el-row>
                            <div
                              style="
                                margin: 0 0 20px 0;
                                padding: 0 0 0 0;
                                text-align: center;
                              "
                            >
                              <el-popconfirm
                                title="确定要删除这张图片吗？"
                                @onConfirm="handleDeleteImage(img, bankOpenOne.id, 1)"
                              >
                                <el-button
                                  slot="reference"
                                  size="mini"
                                  type="danger"
                                  plain
                                  :disabled="bankOpenOne.is_finish === 2"
                                  >删除</el-button
                                >
                              </el-popconfirm>
                            </div>
                          </div>
                        </div>
                      </el-row>
                      <el-row>
                        <el-divider
                          content-position="left"
                          v-if="bankOpenOne.files.length > 0"
                          >文件编辑</el-divider
                        >
                        <div v-for="(file, index) in bankOpenOne.files" :key="index">
                          <el-col :span="24" class="text-border">
                            <el-col :span="14" :offset="1">
                              <el-tooltip :content="file.file_name" placement="top">
                                <span class="count_style" style="display: inherit">{{
                                  file.file_name
                                }}</span>
                              </el-tooltip>
                            </el-col>
                            <el-col :span="4"
                              ><el-button
                                size="mini"
                                type="success"
                                plain
                                @click="downloadFile(file.file_url)"
                                >下载文件</el-button
                              ></el-col
                            >
                            <el-col :span="4" :offset="1">
                              <el-popconfirm
                                title="确定要删除这个文件吗？"
                                @onConfirm="
                                  handleDeleteImage(file.file_url, bankOpenOne.id, 1)
                                "
                              >
                                <el-button
                                  slot="reference"
                                  size="mini"
                                  type="danger"
                                  plain
                                  :disabled="bankOpenOne.is_finish === 2"
                                  >删除</el-button
                                >
                              </el-popconfirm>
                            </el-col>
                          </el-col>
                        </div>
                      </el-row>
                    </el-collapse-item>
                  </el-collapse>
                </el-col>
              </el-row>
            </div>
          </el-card>
          <el-card class="box-card" style="margin-top: 20px">
            <div slot="header" class="clearfix">
              <span class="header-text">开户办理</span>
              <el-popconfirm
                title="确认完成吗？"
                @onConfirm="overCurrentItem(bankOpenTwo.id, 2)"
              >
                <el-button
                  style="float: right"
                  slot="reference"
                  type="success"
                  size="mini"
                  :disabled="bankOpenTwo.is_finish === 2"
                  plain
                  >完成</el-button
                >
              </el-popconfirm>
            </div>
            <div class="text item">
              <el-row>
                <el-col :span="24">
                  <el-form :model="addForm" ref="addForm" label-width="100px" size="mini">
                    <el-card class="box-card m-col">
                      <el-upload
                        multiple
                        ref="upload"
                        action="#"
                        :limit="5"
                        :on-preview="handleLicensePreview"
                        :on-change="handleLicenseChange2"
                        :on-remove="handleLicenseRemove2"
                        :file-list="licenseList2"
                        accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                        list-type="file"
                        :auto-upload="false"
                      >
                        <el-link slot="trigger" type="primary" style="line-height: 28px"
                          >选择文件(最多可选择5个文件)</el-link
                        >
                        <el-button
                          type="primary"
                          size="mini"
                          style="float: right"
                          @click="submitAddUpload('addForm', 2)"
                          :disabled="bankOpenTwo.is_finish === 2"
                          >上传文件</el-button
                        >
                      </el-upload>
                    </el-card>
                    <el-input
                      v-paste="handleParse2"
                      type="textarea"
                      placeholder="请点击此处，再粘贴复制的截图"
                    />
                  </el-form>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0">
                <el-col>
                  <el-collapse v-model="collapseTwo" accordion>
                    <el-collapse-item title="文件信息">
                      <el-row>
                        <el-col>
                          <el-col :span="24">
                            <el-col :span="12">
                              <el-col :span="8">操作人员：</el-col>
                              <el-col :span="16">{{
                                bankOpenTwo.handle_name ? bankOpenTwo.handle_name : ""
                              }}</el-col>
                            </el-col>
                            <el-col :span="12">
                              <el-col :span="8">操作时间：</el-col>
                              <el-col :span="16">{{ bankOpenTwo.update_at }}</el-col>
                            </el-col>
                          </el-col>
                        </el-col>
                      </el-row>
                      <el-row style="margin-bottom: 0; padding-bottom: 0">
                        <div class="demo-image__preview">
                          <el-divider
                            content-position="left"
                            v-if="bankOpenTwo.images.length > 0"
                            >图片编辑</el-divider
                          >
                          <div
                            style="float: left"
                            v-for="(img, index) in bankOpenTwo.images"
                            :key="index"
                          >
                            <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                              <el-image
                                style="width: 100px; height: 100px; padding: 0 5px 0 0"
                                :src="img"
                                :preview-src-list="bankOpenTwo.images"
                              >
                              </el-image>
                            </el-row>
                            <div
                              style="
                                margin: 0 0 20px 0;
                                padding: 0 0 0 0;
                                text-align: center;
                              "
                            >
                              <el-popconfirm
                                title="确定要删除这张图片吗？"
                                @onConfirm="handleDeleteImage(img, bankOpenTwo.id, 1)"
                              >
                                <el-button
                                  slot="reference"
                                  size="mini"
                                  type="danger"
                                  plain
                                  :disabled="bankOpenTwo.is_finish === 2"
                                  >删除</el-button
                                >
                              </el-popconfirm>
                            </div>
                          </div>
                        </div>
                      </el-row>
                      <el-row>
                        <el-divider
                          content-position="left"
                          v-if="bankOpenTwo.files.length > 0"
                          >文件编辑</el-divider
                        >
                        <div v-for="(file, index) in bankOpenTwo.files" :key="index">
                          <el-col :span="24" class="text-border">
                            <el-col :span="14" :offset="1">
                              <el-tooltip :content="file.file_name" placement="top">
                                <span class="count_style" style="display: inherit">{{
                                  file.file_name
                                }}</span>
                              </el-tooltip>
                            </el-col>
                            <el-col :span="4"
                              ><el-button
                                size="mini"
                                type="success"
                                plain
                                @click="downloadFile(file.file_url)"
                                >下载文件</el-button
                              ></el-col
                            >
                            <el-col :span="4" :offset="1">
                              <el-popconfirm
                                title="确定要删除这个文件吗？"
                                @onConfirm="
                                  handleDeleteImage(file.file_url, bankOpenTwo.id, 1)
                                "
                              >
                                <el-button
                                  slot="reference"
                                  size="mini"
                                  type="danger"
                                  plain
                                  :disabled="bankOpenTwo.is_finish === 2"
                                  >删除</el-button
                                >
                              </el-popconfirm>
                            </el-col>
                          </el-col>
                        </div>
                      </el-row>
                    </el-collapse-item>
                  </el-collapse>
                </el-col>
              </el-row>
            </div>
          </el-card>
          <el-card class="box-card" style="margin-top: 20px">
            <div slot="header" class="clearfix">
              <span class="header-text">开户完成</span>
              <el-popconfirm
                title="确认完成吗？"
                @onConfirm="overCurrentItem(bankOpenThree.id, 3)"
              >
                <el-button
                  style="float: right"
                  slot="reference"
                  type="success"
                  size="mini"
                  :disabled="bankOpenThree.is_finish === 2"
                  plain
                  >完成</el-button
                >
              </el-popconfirm>
            </div>
            <div class="text item">
              <el-divider content-position="left"
                ><span class="top-line">银行账户信息</span></el-divider
              >
              <el-row>
                <el-col :span="4" class="m-label">
                  <el-tooltip content="开户银行" placement="top">
                    <span class="count_style" style="display: inherit">开户银行：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="7" class="m-label">
                  <el-input
                    v-model="addForm.bank_detail_name"
                    placeholder="请输入开户银行"
                    size="mini"
                    clearable
                  ></el-input>
                </el-col>
                <el-col :span="4" :offset="1" class="m-label">
                  <el-tooltip content="银行卡账号" placement="top">
                    <span class="count_style" style="display: inherit">银行卡账号：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="7" class="m-label">
                  <el-input
                    v-model="addForm.bank_account"
                    placeholder="请输入银行卡账号"
                    size="mini"
                    clearable
                  ></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" class="m-label">
                  <el-tooltip content="账户类型" placement="top">
                    <span class="count_style" style="display: inherit">账户类型：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="20" class="m-label">
                  <el-radio-group v-model="addForm.bank_type" :size="inputSize">
                    <el-radio border :label="1">一般账户</el-radio>
                    <el-radio border :label="2">基本账户</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" class="m-label">回单卡：</el-col>
                <el-col :span="20" class="m-label">
                  <el-radio-group v-model="addForm.back_bill_card" :size="inputSize">
                    <el-radio border :label="1">未知</el-radio>
                    <el-radio border :label="2">无</el-radio>
                    <el-radio border :label="3">有</el-radio>
                  </el-radio-group>
                </el-col>
              </el-row>
              <el-divider content-position="left"
                ><span class="top-line">基本存款账户信息</span></el-divider
              >
              <el-row>
                <el-col :span="4" class="m-label">
                  <el-tooltip content="基本存款账户编号" placement="top">
                    <span class="count_style" style="display: inherit"
                      >基本存款账户编号：</span
                    >
                  </el-tooltip>
                </el-col>
                <el-col :span="7" class="m-label">
                  <el-input
                    v-model="addForm.base_account_num"
                    placeholder="请输入基本存款账户编号"
                    size="mini"
                    clearable
                  ></el-input>
                </el-col>
                <el-col :span="4" :offset="1" class="m-label">
                  <el-tooltip content="基本存款账户编号时间" placement="top">
                    <span class="count_style" style="display: inherit"
                      >基本存款账户编号时间：</span
                    >
                  </el-tooltip>
                </el-col>
                <el-col :span="7" class="m-label">
                  <el-date-picker
                    v-model="addForm.base_account_at"
                    type="date"
                    placeholder="选择请选择基本存款账户编号时间日期"
                    format="yyyy 年 MM 月"
                    value-format="yyyy-MM-dd"
                    size="mini"
                    clearable
                  >
                  </el-date-picker>
                  <!-- <el-input v-model="addForm.base_account_at" placeholder="请选择基本存款账户编号时间" size="mini" clearable></el-input> -->
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form :model="addForm" ref="addForm" label-width="100px" size="mini">
                    <el-card class="box-card m-col">
                      <el-upload
                        multiple
                        ref="upload"
                        action="#"
                        :limit="5"
                        :on-preview="handleLicensePreview"
                        :on-change="handleLicenseChange3"
                        :on-remove="handleLicenseRemove3"
                        :file-list="licenseList3"
                        accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                        list-type="file"
                        :auto-upload="false"
                      >
                        <el-link slot="trigger" type="primary" style="line-height: 28px"
                          >选择文件(最多可选择5个文件)</el-link
                        >
                      </el-upload>
                    </el-card>
                    <el-input
                      v-paste="handleParse3"
                      type="textarea"
                      placeholder="请点击此处，再粘贴复制的截图"
                    />
                  </el-form>
                </el-col>
              </el-row>
              <el-row>
                <el-col class="tr"
                  ><el-button
                    type="primary"
                    size="mini"
                    style="float: right"
                    @click="submitAddUpload('addForm', 3)"
                    :disabled="bankOpenThree.is_finish === 2"
                    >提交</el-button
                  ></el-col
                >
              </el-row>
              <el-row style="margin-bottom: 0">
                <el-col>
                  <el-collapse v-model="collapseThree" accordion>
                    <el-collapse-item title="文件信息">
                      <el-row>
                        <el-col>
                          <el-col :span="24">
                            <el-col :span="12">
                              <el-col :span="8">操作人员：</el-col>
                              <el-col :span="16">{{
                                bankOpenThree.handle_name ? bankOpenThree.handle_name : ""
                              }}</el-col>
                            </el-col>
                            <el-col :span="12">
                              <el-col :span="8">操作时间：</el-col>
                              <el-col :span="16">{{ bankOpenThree.update_at }}</el-col>
                            </el-col>
                          </el-col>
                        </el-col>
                      </el-row>
                      <el-row style="margin-bottom: 0; padding-bottom: 0">
                        <div class="demo-image__preview">
                          <el-divider
                            content-position="left"
                            v-if="bankOpenThree.images.length > 0"
                            >图片编辑</el-divider
                          >
                          <div
                            style="float: left"
                            v-for="(img, index) in bankOpenThree.images"
                            :key="index"
                          >
                            <el-row style="margin: 0 0 0 0; padding: 0 0 0 0">
                              <el-image
                                style="width: 100px; height: 100px; padding: 0 5px 0 0"
                                :src="img"
                                :preview-src-list="bankOpenThree.images"
                              >
                              </el-image>
                            </el-row>
                            <div
                              style="
                                margin: 0 0 20px 0;
                                padding: 0 0 0 0;
                                text-align: center;
                              "
                            >
                              <el-popconfirm
                                title="确定要删除这张图片吗？"
                                @onConfirm="handleDeleteImage(img, bankOpenThree.id, 1)"
                              >
                                <el-button
                                  slot="reference"
                                  size="mini"
                                  type="danger"
                                  plain
                                  :disabled="bankOpenThree.is_finish === 2"
                                  >删除</el-button
                                >
                              </el-popconfirm>
                            </div>
                          </div>
                        </div>
                      </el-row>
                      <el-row>
                        <el-divider
                          content-position="left"
                          v-if="bankOpenThree.files.length > 0"
                          >文件编辑</el-divider
                        >
                        <div v-for="(file, index) in bankOpenThree.files" :key="index">
                          <el-col :span="24" class="text-border">
                            <el-col :span="14" :offset="1">
                              <el-tooltip :content="file.file_name" placement="top">
                                <span class="count_style" style="display: inherit">{{
                                  file.file_name
                                }}</span>
                              </el-tooltip>
                            </el-col>
                            <el-col :span="4"
                              ><el-button
                                size="mini"
                                type="success"
                                plain
                                @click="downloadFile(file.file_url)"
                                >下载文件</el-button
                              ></el-col
                            >
                            <el-col :span="4" :offset="1">
                              <el-popconfirm
                                title="确定要删除这个文件吗？"
                                @onConfirm="
                                  handleDeleteImage(file.file_url, bankOpenThree.id, 1)
                                "
                              >
                                <el-button
                                  slot="reference"
                                  size="mini"
                                  type="danger"
                                  plain
                                  :disabled="bankOpenThree.is_finish === 2"
                                  >删除</el-button
                                >
                              </el-popconfirm>
                            </el-col>
                          </el-col>
                        </div>
                      </el-row>
                    </el-collapse-item>
                  </el-collapse>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="企业微信聊天记录"
      :visible.sync="wxChatDrawer"
      direction="rtl"
      :before-close="handleWxChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat
            :chatId="wxWorkChatId"
            :chatName="wxWorkchatCompany"
          ></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import WxWorkChat from "common/WxWorkChat";
import CallLogs from "common/CallLogs";
import OrderInfo from "common/OrderInfo";
import CompanyInfo from "common/CompanyInfo";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';
import PhoneCom from "common/PhoneCom";

export default {
  name: "BankOpen",
  components: {
    CallLogs,
    CompanyInfo,
    OrderInfo,
    WxWorkChat,
    PhoneCom
  },
  data() {
    return {
      addtionData: { value: "自助下单", label: "自助下单" },
      wxChatDrawer: false,
      bankCheckType: this.$feedBackConfig.order_service,
      wxWorkChatId: "",
      wxWorkchatCompany: "",
      editDrawer: false,
      loading: false,
      callLogsDrawer: false,
      companyInfoDrawer: false,
      searchVisible: false,
      activeName: "info",
      isOvered: false,
      oneOvered: false,
      orderId: null,
      orderNum: "",
      winIndex: null,
      companyId: null,
      companyInfoId: null,
      companyName: "",
      typeArr: [],
      logs: [],
      users: [],
      parks: [],
      items: [],
      combos: [],
      tax_cates: [],
      regTypes: [],
      features: [],
      orders: [],
      companies: [],
      orderNums: [],
      company: "",
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      collapseOne: ["1"],
      collapseTwo: ["1"],
      collapseThree: ["1"],
      licenseList1: [],
      licenseList2: [],
      licenseList3: [],
      formData: null,
      inputSize: "mini",
      fromOptions: [],
      addForm: {
        index: null,
        cid: null,
        order_id: null,
        type: null,
        bank_name: "",
        bank_detail_name: "",
        area: "",
        bank_address: "",
        is_present: "",
        bank_account: "",
        bank_type: "",
        base_account_num: "",
        base_account_at: "",
        back_bill_card: "",
      },
      searchArr: {
        id: null,
        status: "",
        step: "",
        service_status: "",
        consultant: null,
        feature: null,
        actual_reg_type: null,
        operator: null,
        platform: null,
        park: null,
        company_id: null,
      },
      bankOpenOne: {
        id: null,
        order_id: null,
        type: null,
        handle_id: null,
        handle_name: "",
        update_at: "",
        is_finish: null,
        messages: [],
        images: [],
        files: [],
      },
      bankOpenTwo: {
        id: null,
        order_id: null,
        type: null,
        handle_id: null,
        handle_name: "",
        update_at: "",
        is_finish: null,
        messages: [],
        images: [],
        files: [],
      },
      bankOpenThree: {
        id: null,
        order_id: null,
        type: null,
        handle_id: null,
        handle_name: "",
        update_at: "",
        is_finish: null,
        messages: [],
        images: [],
        files: [],
      },
      orderInfoVisible: false,
      orderInfoId: null,
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 30, // 每页显示条数
      },
      searchLoading: false,
      searchCompanies: [],
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }

      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
    usersConvert() {
      return [this.addtionData, ...this.users];
    },
  },
  methods: {
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkchatCompany = "";
      done();
    },
    handleWxChatOpen(chat, companyName) {
      if (chat) {
        this.wxChatDrawer = true;
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id;
          this.wxWorkchatCompany = companyName;
        });
      }
    },
    handelGetOrders() {
      this.$axios
        .get("/api/bank_open?page=" + this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize + this.searchStr)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.orders = data.data.orders.data;
            this.users = data.data.users;
            this.parks = data.data.parks;
            this.items = data.data.items;
            this.combos = data.data.combos;
            this.tax_cates = data.data.tax_cates;
            this.regTypes = data.data.regTypes;
            this.features = data.data.features;
            this.pageOption.total = data.data.orders.total;
          }
        });
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.handelGetOrders();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.handelGetOrders();
    },
    remoteCompanyMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    handleCompanyChange() {
      this.$axios
        .post("/api/industry/change/save_company/" + this.orderId, {
          cid: this.companyId,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.companyName = data.data.cname;
            this.orders[this.winIndex].company_id = this.companyId;
            this.orders[this.winIndex].company = data.data.cname;
            this.$message.success(data.msg);
          }
        });
    },
    handleOrderInfo(orderId, order_num) {
      this.orderInfoVisible = true;
      setTimeout(() => {
        this.orderInfoId = orderId;
        this.orderNum = order_num;
      });
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null;
      done();
    },
    handleCompanyInfoBeforeClose(done) {
      this.companyInfoId = null;
      done();
    },
    fhandleCompanyInfoOpen(cid) {
      this.companyInfoDrawer = true;
      setTimeout(() => {
        this.companyInfoId = cid;
      });
    },
    handCallLogsOpen(row) {
      this.callLogsDrawer = true;
      setTimeout(() => {
        if (row.customer_phone) this.callPhone1.push(row.customer_phone);
        if (row.corporate_phone) this.callPhone2.push(row.corporate_phone);
        if (row.company_obj) {
          this.company = row.company_obj.company_name;
          if (row.company_obj.user) this.callPhone.push(row.company_obj.user.phone);
          if (row.company_obj.docking_phone)
            this.callPhone3.push(row.company_obj.docking_phone);
        }
      });
    },
    handleCallLogsBeforeClose(done) {
      this.company = "";
      this.callPhone = [];
      this.callPhone1 = [];
      this.callPhone2 = [];
      this.callPhone3 = [];
      done();
    },
    handleEditOpen(index, row) {
      this.orderId = row.id;
      this.addForm.order_id = row.id;
      this.addForm.index = index;
      this.addForm.cid = row.company_id;
      this.winIndex = index;
      this.orderNum = row.order_num;
      this.companyName = row.company;
      if (row.bank_open_one) {
        this.addForm.bank_name = row.bank_open_one.messages.bank_name;
        this.addForm.bank_detail_name = row.bank_open_one.messages.bank_detail_name;
        this.addForm.area = row.bank_open_one.messages.area;
        this.addForm.bank_address = row.bank_open_one.messages.bank_address;
        this.addForm.is_present = row.bank_open_one.messages.is_present;
        this.setDataByType(row.bank_open_one, 1);
      }
      if (row.bank_open_two) {
        this.setDataByType(row.bank_open_two, 2);
      }
      if (row.bank_open_three) {
        this.addForm.bank_account = row.bank_open_three.messages.bank_account;
        this.addForm.bank_type = row.bank_open_three.messages.bank_type;
        this.addForm.base_account_num = row.bank_open_three.messages.base_account_num;
        this.addForm.base_account_at = row.bank_open_three.messages.base_account_at;
        this.addForm.back_bill_card = row.bank_open_three.messages.back_bill_card;
        this.setDataByType(row.bank_open_three, 3);
      }
      this.editDrawer = true;
    },
    setDataByType(row, type) {
      if (type === 1) {
        this.bankOpenOne.id = row.id;
        this.bankOpenOne.order_id = row.order_id;
        this.bankOpenOne.type = row.type;
        this.bankOpenOne.handle_id = row.handle_id;
        this.bankOpenOne.handle_name = row.admin.username;
        this.bankOpenOne.update_at = row.handle_at;
        this.bankOpenOne.is_finish = row.is_finish;
        this.bankOpenOne.messages = row.messages;
        this.bankOpenOne.files = row.files;
        if (row.images.length > 0) {
          this.bankOpenOne.images = [];
          for (let key in row.images) {
            this.bankOpenOne.images.push(row.images[key].image_url);
          }
        }
      }
      if (type === 2) {
        this.bankOpenTwo.id = row.id;
        this.bankOpenTwo.order_id = row.order_id;
        this.bankOpenTwo.type = row.type;
        this.bankOpenTwo.handle_id = row.handle_id;
        this.bankOpenTwo.handle_name = row.admin.username;
        this.bankOpenTwo.update_at = row.handle_at;
        this.bankOpenTwo.is_finish = row.is_finish;
        this.bankOpenTwo.messages = row.messages;
        this.bankOpenTwo.files = row.files;
        if (row.images.length > 0) {
          this.bankOpenTwo.images = [];
          for (let key in row.images) {
            this.bankOpenTwo.images.push(row.images[key].image_url);
          }
        }
      }
      if (type === 3) {
        this.bankOpenThree.id = row.id;
        this.bankOpenThree.order_id = row.order_id;
        this.bankOpenThree.type = row.type;
        this.bankOpenThree.handle_id = row.handle_id;
        this.bankOpenThree.handle_name = row.admin.username;
        this.bankOpenThree.update_at = row.handle_at;
        this.bankOpenThree.is_finish = row.is_finish;
        this.bankOpenThree.messages = row.messages;
        this.bankOpenThree.files = row.files;
        if (row.images.length > 0) {
          this.bankOpenThree.images = [];
          for (let key in row.images) {
            this.bankOpenThree.images.push(row.images[key].image_url);
          }
        }
      }
    },
    handleLicensePreview(file) {},
    handleLicenseChange1(file, fileList) {
      this.licenseList1 = fileList;
    },
    handleLicenseChange2(file, fileList) {
      this.licenseList2 = fileList;
    },
    handleLicenseChange3(file, fileList) {
      this.licenseList3 = fileList;
    },
    handleLicenseRemove1(file, fileList) {
      this.licenseList1 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList1.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove2(file, fileList) {
      this.licenseList2 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList2.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleLicenseRemove3(file, fileList) {
      this.licenseList3 = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList3.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleParse1(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList1.length < 5) {
            that.licenseList1.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse2(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList2.length < 5) {
            that.licenseList2.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleParse3(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList3.length < 5) {
            that.licenseList3.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    submitAddUpload(refs, type) {
      this.formData = new FormData();
      if (type === 1) {
        if (!this.addForm.bank_name) {
          this.$message.error("请选择银行名称");
          return;
        }
        if (!this.addForm.bank_detail_name) {
          this.$message.error("请输入开户银行全称");
          return;
        }
        if (!this.addForm.area) {
          this.$message.error("请选择区域");
          return;
        }
        if (!this.addForm.bank_address) {
          this.$message.error("请输入银行地址");
          return;
        }
        if (!this.addForm.is_present) {
          this.$message.error("请选择客户是否到场");
          return;
        }
        this.licenseList1.forEach((file) => this.formData.append("file[]", file.raw));
      }
      if (type === 2) {
        if (this.licenseList2.length === 0) {
          this.$message.error("请上传办理文件");
          return;
        }
        this.licenseList2.forEach((file) => this.formData.append("file[]", file.raw));
      }
      if (type === 3) {
        if (!this.addForm.bank_detail_name) {
          this.$message.error("请输入开户银行全称");
          return;
        }
        if (!this.addForm.bank_account) {
          this.$message.error("请输入银行账户");
          return;
        }
        if (!this.addForm.bank_type) {
          this.$message.error("请选择账户类型");
          return;
        }
        if (!this.addForm.base_account_num) {
          this.$message.error("请输入基本存款账号编号");
          return;
        }
        if (!this.addForm.base_account_at) {
          this.$message.error("请选择基本存款账号日期");
          return;
        }
        if (!this.addForm.back_bill_card) {
          this.$message.error("请选择是否有回单卡");
          return;
        }
        this.licenseList3.forEach((file) => this.formData.append("file[]", file.raw));
      }
      this.addForm.type = type;
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
      this.$axios
        .post("/api/bank_open/upload/" + this.orderId, this.formData)
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            if (type === 1) {
              this.orders[this.winIndex].bank_open_one = data.data;
              this.setDataByType(data.data, 1);
            }
            if (type === 2) {
              this.orders[this.winIndex].bank_open_two = data.data;
              this.setDataByType(data.data, 2);
            }
            if (type === 3) {
              this.orders[this.winIndex].bank_open_three = data.data;
              this.setDataByType(data.data, 3);
            }
            this.licenseList1 = [];
            this.licenseList2 = [];
            this.licenseList3 = [];
            this.$message.success(data.msg);
            this.formData = null;
            this.$refs[refs].resetFields();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleDeleteImage(path, rid, type) {
      this.$axios.post("/api/bank_open/delete", { path: path, rid: rid }).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          if (type === 1) {
            this.orders[this.winIndex].bank_open_one = data.data;
            this.setDataByType(data.data, 1);
          }
          if (type === 2) {
            this.orders[this.winIndex].bank_open_two = data.data;
            this.setDataByType(data.data, 2);
          }
          if (type === 3) {
            this.orders[this.winIndex].bank_open_three = data.data;
            this.setDataByType(data.data, 3);
          }
          this.$message.success(data.msg);
        }
      });
    },
    overCurrentItem(rid, type) {
      this.$axios.post("/api/bank_open/over_item/" + rid).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          if (type === 1) {
            this.orders[this.winIndex].bank_open_one.is_finish = data.data;
            this.setDataByType(data.data, 1);
          }
          if (type === 2) {
            this.orders[this.winIndex].bank_open_two = data.data;
            this.setDataByType(data.data, 2);
          }
          if (type === 3) {
            this.orders[this.winIndex].bank_open_three = data.data;
            this.setDataByType(data.data, 3);
          }
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleClearList() {
      this.editDrawer = false;
      this.orderId = null;
      this.addForm.order_id = null;
      this.addForm.index = null;
      this.addForm.cid = null;
      this.winIndex = null;
      this.orderNum = "";
      this.companyName = "";
      this.addForm.bank_name = "";
      this.addForm.bank_detail_name = "";
      this.addForm.area = "";
      this.addForm.bank_address = "";
      this.addForm.is_present = "";
      this.addForm.bank_account = "";
      this.addForm.bank_type = "";
      this.addForm.base_account_num = "";
      this.addForm.base_account_at = "";
      this.addForm.back_bill_card = "";
      this.bankOpenOne.id = null;
      this.bankOpenOne.order_id = null;
      this.bankOpenOne.type = "";
      this.bankOpenOne.handle_id = "";
      this.bankOpenOne.handle_name = "";
      this.bankOpenOne.update_at = "";
      this.bankOpenOne.is_finish = "";
      this.bankOpenOne.messages = [];
      this.bankOpenOne.files = [];
      this.bankOpenOne.images = [];
      this.bankOpenTwo.id = null;
      this.bankOpenTwo.order_id = null;
      this.bankOpenTwo.type = "";
      this.bankOpenTwo.handle_id = "";
      this.bankOpenTwo.handle_name = "";
      this.bankOpenTwo.update_at = "";
      this.bankOpenTwo.is_finish = "";
      this.bankOpenTwo.messages = [];
      this.bankOpenTwo.files = [];
      this.bankOpenTwo.images = [];
      this.bankOpenThree.id = null;
      this.bankOpenThree.order_id = null;
      this.bankOpenThree.type = "";
      this.bankOpenThree.handle_id = "";
      this.bankOpenThree.handle_name = "";
      this.bankOpenThree.update_at = "";
      this.bankOpenThree.is_finish = "";
      this.bankOpenThree.messages = [];
      this.bankOpenThree.files = [];
      this.bankOpenThree.images = [];
    },
    searchRemoteCompanyMethod(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchArrItemCompanys(query);
        }, 200);
      } else {
        this.searchCompanies = [];
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompanies = data.data.companies;
        }
      });
    },
    handleSearchCompanyChange(val) {
      this.pageOption.currentPage = 1;
      this.handelGetOrders();
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchOrders(query);
        }, 200);
      } else {
        this.orderNums = [];
      }
    },
    searchOrders(query) {
      this.$axios.get("/api/admin/searchOrders?num=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.orderNums = data.data.orderNum;
        }
      });
    },
    handleOrderChange() {
      this.pageOption.currentPage = 1;
      this.handelGetOrders();
    },
    downloadFile(url) {
      window.open(url);
    },
    handleClearSearchGetData() {
      this.searchArr.service_status = "";
      this.searchArr.consultant = null;
      this.searchArr.feature = null;
      this.searchArr.actual_reg_type = null;
      this.searchArr.operator = null;
      this.searchArr.platform = null;
      this.searchArr.park = null;
      this.searchStr.company_id = null;
      this.pageOption.currentPage = 1;
      this.searchVisible = false;
      this.handelGetOrders();
    },
    handleSearchGetData() {
      this.searchVisible = false;
      this.pageOption.currentPage = 1;
      this.handelGetOrders();
    },
    getFrom() {
      this.$axios
        .get("api/admin/other_orders/get_froms")
        .then(({ data }) => {
          if (data.code === 1) {
            this.fromOptions = data.data;
          }
        })
        .catch();
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    }
  },
  mounted() {
    this.handelGetOrders();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
[v-cloak]
  display: none
.m-col
  margin: 8px 0 8px 0
.text-border
  border: 1px solid #dcdfe6
  border-radius: 5px
  line-height: 45px
  margin-bottom: .1rem
.count_style
  line-height: 28px
  display: inherit
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
.border-line
  border: solid 1px red
.header-text
  line-height: 28px
  font-size: 16px
  color: #4d84fe
.card-margin
  margin-bottom: .4rem
.count_style
  display: inherit
  overflow: hidden
  text-overflow: ellipsiss
  white-space: nowrap
.check-succ
  color: #67C23A
.setBadge >>> .el-badge__content.is-fixed
  top: .22rem
  right: .06rem
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.bank_open >>> .el-drawer__header
  font-size: .36rem
  font-weight: 400
  color: #4D84FE
.bank_open >>> .el-table__header th
  color: #333333
.bank_open >>> .el-timeline-item__node--normal
  left: 0
  background-color: #ECF4FF
.el-select, .el-cascader
  width: 100%
.bank_open
  marginLeft()
  .count-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.clearfix:before,
.clearfix:after
  display: table
  content: ""
.clearfix:after
  clear: both
.search-row .el-col
  margin-bottom: .2rem
.count
  padding-left: .2rem
  line-height: .56rem
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.tr
  text-align: right
.top-line
  color: #409EFF
  font-weight: bold
.dot
  display: inline-block
  width: 0.1rem
  height: 0.1rem
  border-radius: 50%
  margin-right: 0.1rem
  top: 0
  left: -.2rem
  bottom: 0
  margin: auto
.mt-50
  margin-top: 1rem
.mt-10
  margin-top: .2rem
.mb-10
  margin-bottom: .2rem
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  .tabs-title
    color: #5789F4
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
  .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
.el-date-editor
  width: 100% !important
.ellipsis-link
  display: inline-block
  max-width: 100%
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
.page-footer
  position: fixed
  bottom: 0
  left: 0
  height: 80px
  background: #fff
  width: 100%
  z-index: 2
.pagination-style
  padding-top: 15px
  text-align: right
.AIdrawer .drawer-title
  background-color: #ecf5ff
  padding: 10px
  color: #409EFF
</style>



// WEBPACK FOOTER //
// src/pages/customer/BankOpen.vue